import { QuestionEntry } from '@wix/ambassador-faq-question-entry-v2-question-entry/types';
import React, { useContext } from 'react';
import { Text } from 'wix-ui-tpa/cssVars';
import RCV from '../../../RCV';
import { st, classes } from '../../styles.st.css';
import { DraftJSObject } from '../../../../../../types/RichContent';
import { ISettingsContextValue } from '@wix/tpa-settings';
import { useSettings, useStyles } from '@wix/tpa-settings/react';
import { AccordionCSS } from '../../Interfaces';
import settingsParams from '../../../../settingsParams';
import { useEnvironment } from '@wix/yoshi-flow-editor';
import SocialWrapper from '../../../SocialWrapper/SocialWrapper';
import { DATA_HOOKS } from '../../../../../../constants/dataHooksElements';
import stylesParams from '../../../../stylesParams';
import { AppContext } from '../../../SettingsProvider/SettingsProvider';
import { useLayoutType } from '../../../../../../hooks/useLayoutType';

const ListOneColumn = ({
  filteredQuestions,
}: {
  filteredQuestions: QuestionEntry[];
}) => {
  const styles = useStyles();
  const { isEditor3 } = useContext(AppContext);
  const {
    itemAppearance,
    spacing: { gap },
  } = useLayoutType(isEditor3);
  const questionFontParam = styles.get?.(stylesParams.questionTextFont);
  // Extract settings for item appearance and animation

  const customStyle = {
    '--item-gap': `${gap}px`,
  } as AccordionCSS;

  const columnId = filteredQuestions[0]?.id || '';

  return (
    <div
      style={customStyle}
      className={st(classes.listLayout)}
      role="list"
      data-hook={DATA_HOOKS.WIDGET_LIST_ONE_COLUMN(columnId)}
    >
      {filteredQuestions.map((item: QuestionEntry, index) => {
        const { id, question, draftjs } = item;
        const parsedDraftjs: DraftJSObject = JSON.parse(draftjs!);
        return (
          <div
            className={st(classes.listWrapperBorder, { itemAppearance })}
            key={id!}
            id={id!}
            role="listitem"
          >
            <div className={st(classes.listWrapperAccordion)} tabIndex={0}>
              <Text
                tagName={questionFontParam.htmlTag}
                key={`question-${id}`}
                className={st(classes.question)}
                data-hook={DATA_HOOKS.LIST_ITEM_QUESTION(columnId + index)}
              >
                {question!}
              </Text>
              <Text
                key={`answer-${id}`}
                className={st(classes.answer)}
                data-hook={DATA_HOOKS.LIST_ITEM_ANSWER(columnId + index)}
                role="region"
              >
                {parsedDraftjs && <RCV convertAnswerToJSON={parsedDraftjs} />}
              </Text>
            </div>
            <SocialWrapper questionId={id!} />
          </div>
        );
      })}
    </div>
  );
};

export default ListOneColumn;
